'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp; /* eslint-disable max-len */
/* eslint-disable no-undef */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _FormInput = require('../FormInput');

var _redirectable = require('../../helpers/redirectable');

var _redirectable2 = _interopRequireDefault(_redirectable);

var _createApiClient = require('../../helpers/createApiClient');

var _createApiClient2 = _interopRequireDefault(_createApiClient);

var _AdyenKlarnaComponentStyle = require('./AdyenKlarnaComponentStyle.scss');

var _AdyenKlarnaComponentStyle2 = _interopRequireDefault(_AdyenKlarnaComponentStyle);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdyenKlarnaComponent = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _redirectable2.default)(), _dec4 = (0, _reactCssModules2.default)(_AdyenKlarnaComponentStyle2.default), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AdyenKlarnaComponent, _React$Component);

  function AdyenKlarnaComponent(props) {
    (0, _classCallCheck3.default)(this, AdyenKlarnaComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdyenKlarnaComponent.__proto__ || (0, _getPrototypeOf2.default)(AdyenKlarnaComponent)).call(this, props));

    _this.state = {
      submit: false
    };
    return _this;
  }

  (0, _createClass3.default)(AdyenKlarnaComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.props.active) {
        return;
      }

      var _props = this.props,
          t = _props.t,
          order = _props.order,
          store = _props.config.store,
          lng = _props.params.lng,
          setPaymentError = _props.setPaymentError;
      var paymentMethodsResponse = order.paymentMethodsResponse,
          locale = order.locale,
          countryCode = order.billAddress.country.iso;
      var _store$adyenCheckout = store.adyenCheckout,
          clientKey = _store$adyenCheckout.clientKey,
          environment = _store$adyenCheckout.environment;
      var adyenCheckout = window.AdyenWeb.AdyenCheckout;


      adyenCheckout({
        paymentMethodsResponse: paymentMethodsResponse,
        clientKey: clientKey,
        locale: locale,
        countryCode: countryCode,
        environment: environment,
        onSubmit: function onSubmit(state, component) {
          setPaymentError('');

          // In case the flash message was not removed
          sessionStorage.removeItem('flash-error');

          var getTaxPercentage = function getTaxPercentage(lineItem) {
            if (Array.isArray(order.taxRates)) {
              var taxRate = order.taxRates.find(function (_ref) {
                var id = _ref.id;
                return id === lineItem.taxCategoryId;
              });
              if (taxRate) {
                return parseFloat(taxRate.amount) * 10000;
              }
            }
            return undefined;
          };

          var paymentData = (0, _extends3.default)({}, state.data, {
            shopperEmail: order.email,
            channel: 'web',
            countryCode: countryCode,
            lineItems: order.lineItems.map(function (item) {
              return {
                amountExcludingTax: parseFloat(item.preTaxAmount) * 100,
                amountIncludingTax: parseFloat(item.total) * 100,
                description: item.variant.description,
                id: item.variant.id,
                imageUrl: item.variant.displayImage,
                productUrl: (0, _localisedPaths.localisedUrl)(store, item.variant.slug, order.locale),
                quantity: item.quantity,
                taxAmount: parseFloat(item.includedTaxTotal) * 100,
                taxPercentage: getTaxPercentage(item)
              };
            }),
            returnUrl: '' + (0, _localisedPaths.localisedUrl)(store, 'adyenCheckoutApiReturn', lng) + ('?orderNumber=' + order.number + '&orderToken=' + order.token)
          });

          _this2.sendPayment(paymentData).then(function (response) {
            if (response.action) {
              component.handleAction(response.action);
            } else {
              _this2.handlePaymentResult(response);
            }
            _this2.submitUnlock();
          }, function () {
            setPaymentError(t('spree.adyen_cse.gateway_errors.default_refusal_reason'));
            _this2.submitUnlock();
          });
        },
        onAdditionalDetails: function onAdditionalDetails(state, component) {
          return _this2.sendPaymentDetails(state.data).then(function (response) {
            if (response.action) {
              component.handleAction(response.action);
            } else {
              _this2.handlePaymentResult(response);
            }
          }, function () {
            setPaymentError(t('spree.adyen_cse.gateway_errors.default_refusal_reason'));
          });
        },
        onChange: function onChange() {
          setPaymentError('');
          _this2.submitUnlock();
        },
        amount: {
          value: Math.floor(100 * parseFloat(order.total)),
          currency: order.currency
        }
      }).then(function (checkout) {
        return _this2.initCheckout(checkout);
      });
    }
  }, {
    key: 'initCheckout',
    value: function initCheckout(checkout) {
      var _this3 = this;

      var _props2 = this.props,
          t = _props2.t,
          setCheckoutFormSubmitter = _props2.setCheckoutFormSubmitter,
          setPaymentError = _props2.setPaymentError,
          getTcCheckedState = _props2.getTcCheckedState,
          type = _props2.paymentMethod.type;
      var Klarna = window.AdyenWeb.Klarna;


      var checkoutComponent = new Klarna(checkout, {
        useKlarnaWidget: true,
        type: type,
        onClick: function onClick() {
          setPaymentError('');

          if (getTcCheckedState()) {
            checkoutComponent.submit();
            return;
          }

          setPaymentError(t('spree.adyen_checkout.accept_tcs'));
        }
      });

      checkoutComponent.mount('#' + this.componentContainerName);

      setCheckoutFormSubmitter(function () {
        if (!_this3.submitLock()) {
          return;
        }

        setPaymentError('');
        try {
          checkoutComponent.submit();
        } catch (e) {
          setPaymentError(t('spree.adyen_cse.gateway_errors.default_refusal_reason'));
          _this3.submitUnlock();
        }
      });
    }
  }, {
    key: 'sendPayment',
    value: function sendPayment(paymentData) {
      var _this4 = this;

      var t = this.props.t;


      return this.api('/order/payment').post(paymentData).catch(function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(err) {
          var errMsg;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return err.response.json();

                case 3:
                  errMsg = _context.sent;

                  if (!(errMsg && errMsg.error === 'No shipments' && errMsg.redirect)) {
                    _context.next = 7;
                    break;
                  }

                  sessionStorage.setItem('flash-error', (0, _stringify2.default)({ error: t('spree.shipment_failure_message') }));

                  return _context.abrupt('return', _this4.props.localisedRedirect('/checkout/' + errMsg.redirect));

                case 7:
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context['catch'](0);
                  throw err;

                case 12:
                  throw err;

                case 13:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4, [[0, 9]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'sendPaymentDetails',
    value: function sendPaymentDetails(paymentDetailsData) {
      return this.api('/order/payment_details').post(paymentDetailsData);
    }
  }, {
    key: 'handlePaymentResult',
    value: function handlePaymentResult(response) {
      var _props3 = this.props,
          t = _props3.t,
          order = _props3.order,
          setPaymentError = _props3.setPaymentError;
      var resultCode = response.resultCode;


      switch (resultCode) {
        case 'Authorised':
          return this.props.localisedRedirect('/orders/' + order.number);
        case 'Pending':
        case 'Received':
          return this.props.localisedRedirect('/checkout/processing');
        case 'Refused':
          return setPaymentError(t('spree.adyen_cse.gateway_errors.refused'));
        case 'Cancelled':
          return setPaymentError(t('spree.adyen_cse.gateway_errors.cancelled'));
        case 'Error':
        default:
          return setPaymentError(t('spree.adyen_cse.gateway_errors.default_refusal_reason'));
      }
    }
  }, {
    key: 'submitLock',
    value: function submitLock() {
      if (this.state.submit) {
        return false;
      }

      this.setState({ submit: true });

      return true;
    }
  }, {
    key: 'submitUnlock',
    value: function submitUnlock() {
      this.setState({ submit: false });
    }
  }, {
    key: 'renderContainer',
    value: function renderContainer() {
      if (!this.props.active) {
        return null;
      }

      return _react2.default.createElement('div', { id: this.componentContainerName });
    }
  }, {
    key: 'render',
    value: function render() {
      var _context2;

      return _react2.default.createElement(
        'div',
        { styleName: 'paymentRow' },
        _react2.default.createElement(
          _FormInput.Field,
          { inputType: 'radio' },
          _react2.default.createElement(_FormInput.Radio, {
            name: 'order[payments_attributes][0][payment_method_id]',
            id: this.paymentMethodIdAttribute,
            value: '' + this.props.paymentMethodId,
            onChange: (_context2 = this.props).onPaymentSelect.bind(_context2),
            checked: this.props.active,
            required: true,
            disabled: !this.props.selectable
          }),
          _react2.default.createElement(
            _FormInput.Label,
            {
              className: 'a-label a-label--large',
              htmlFor: this.paymentMethodIdAttribute,
              disabled: !this.props.selectable
            },
            this.props.paymentMethod.name
          )
        ),
        this.renderContainer()
      );
    }
  }, {
    key: 'paymentMethodIdAttribute',
    get: function get() {
      var paymentMethodId = this.props.paymentMethodId;

      return 'order_payment_method_' + paymentMethodId;
    }
  }, {
    key: 'api',
    get: function get() {
      var _props$config = this.props.config,
          apiHost = _props$config.apiHost,
          apiPort = _props$config.apiPort;

      return (0, _createApiClient2.default)({ host: apiHost, port: apiPort });
    }
  }, {
    key: 'componentContainerName',
    get: function get() {
      return 'component-container-' + this.paymentMethodIdAttribute;
    }
  }]);
  return AdyenKlarnaComponent;
}(_react2.default.Component), _class2.propTypes = {
  selectable: _react.PropTypes.bool,
  onPaymentSelect: _react.PropTypes.func,
  paymentMethod: _react.PropTypes.object.isRequired,
  paymentMethodId: _react.PropTypes.number,
  active: _react.PropTypes.bool,
  order: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object,
  setCheckoutFormSubmitter: _react.PropTypes.func,
  getTcCheckedState: _react.PropTypes.func,
  setTcCheckedChangeHandler: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  setPaymentError: _react.PropTypes.func
}, _class2.defaultProps = {
  selectable: true,
  active: false,
  onPaymentSelect: function onPaymentSelect() {}
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = AdyenKlarnaComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/AdyenKlarnaComponent.js
// module id = 2489
// module chunks = 0